/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosPromise } from 'axios';
import api from './api';

class CoreService {
  getTarifasPorLinha = (): AxiosPromise => {
    return api.get('api/pjtacom/rates-lines/');
  };

  createContact = (
    name: string,
    email: string,
    comment: string,
    phone?: string,
  ) => {
    return api.post('/api/core/contato/', {
      name,
      email,
      phone,
      comment,
    });
  };
}

export default CoreService;
